import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">观众热评</h2>
          <p className="text-foreground-600">听听真实用户怎么说七七影院</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <article key={comment.id} className="bg-background-50 rounded-xl p-5 border border-background-200/60 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap overflow-hidden text-ellipsis">{comment.name}</h3>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: comment.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                  </div>
                </div>
                <span className="ml-auto text-xs text-foreground-500 whitespace-nowrap">{comment.date}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{comment.content}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}